import {
  CORE_LOAD_ALL_CUSTOMER_REQUEST,
  CORE_LOAD_ALL_CUSTOMER_SUCCESS,
  CORE_LOAD_ALL_CUSTOMER_FAILURE,

  CORE_LOAD_CUSTOMER_REQUEST,
  CORE_LOAD_CUSTOMER_SUCCESS,
  CORE_LOAD_CUSTOMER_FAILURE,

  REQUEST_STATE
} from '../types'

const initialState = []
  , initialStateObj = {}
  , requestState = REQUEST_STATE
export default {
  allCustomer: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_CUSTOMER_REQUEST:
        return requestState
      case CORE_LOAD_ALL_CUSTOMER_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_CUSTOMER_FAILURE:
        return initialState
      default:
        return state
    }
  },
  customerInfo: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_CUSTOMER_REQUEST:
        return requestState
      case CORE_LOAD_CUSTOMER_SUCCESS:
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          return action.payload
        } else return {}
      case CORE_LOAD_CUSTOMER_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerCustomer.js